import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncLoanApproved = loadable(() => import('./LoanApproved'), {
  fallback: <Loader />,
});
